import { useEffect } from 'react';

import { FormControl, FormLabel, Textarea } from '@chakra-ui/react';

import { useAppDispatch } from 'hooks';

import useFormBinderDisabled from 'hooks/useFormBinderDisabled';

import { SharedTextFieldInputProps } from './TextFieldInput.types';

const SharedTextFieldInput = ({
  label,
  value,
  onChange,
  formStateKey,
  formActions,
  section,
  required,
  subLabel,
  ...rest
}: SharedTextFieldInputProps) => {
  const dispatch = useAppDispatch();

  const isDisabled = useFormBinderDisabled(formStateKey);

  const htmlID = subLabel ? `${label} (${subLabel})` : label;

  useEffect(() => {
    if (!required || !formActions) return;

    if (!value || value.length === 0) {
      dispatch(formActions.addMissingMandatoryField({ name: htmlID, section }));
    } else {
      dispatch(formActions.removeMissingMandatoryField(htmlID));
    }
  }, [required, value, htmlID, dispatch, formActions, section]);

  return (
    <FormControl isRequired={required}>
      <FormLabel ml="0">{label}</FormLabel>
      <Textarea
        variant="main"
        disabled={isDisabled}
        value={value}
        onChange={onChange}
        borderColor={
          required && (!value || value.length === 0) ? 'red' : 'inherit'
        }
        id={htmlID}
        {...rest}
      />
    </FormControl>
  );
};

export default SharedTextFieldInput;
